import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText
} from "@mui/material";

const getFieldLabel = (field) => {
  if (typeof field === "string") return field;

  return field?.label || field?.name || field?.fieldName || field?.key || "";
};

function MissingJDFieldsDialog({ open, onClose, fields = [] }) {
  const missingFields = fields.map(getFieldLabel).filter(Boolean);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Missing Fields</DialogTitle>
      <DialogContent>
        <DialogContentText>
          To generate the job description, please fill in the following required fields:
        </DialogContentText>

        <List dense sx={{ mt: 1 }}>
          {missingFields.map((field) => (
            <ListItem key={field} disableGutters>
              <ListItemText primary={field} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MissingJDFieldsDialog;
